import { Box, Menu } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import React, { useState } from "react";

import { dateValues } from "components/dataGridFilter/FiltersData";
import { TextFieldInput } from "new-components/textFieldInput/TextFieldInput";
import { OptionType } from "new-components/textFieldInput/types";

import { Picker } from "./Picker";


export interface DateTimeRangePickerProps {
  handleChangeDate: (columnField: string, value: Record<string, string>) => void;
  value: string;
  valueOptions:
    | {
        value: string;
        name: string;
      }[]
    | undefined;
}

export function DateTimeRangePicker(props: DateTimeRangePickerProps) {
  const { handleChangeDate, value, valueOptions = [] } = props;

  const defaultValue = !dateValues.includes(value) ? "custom" : value;

  const [currentOption, setCurrentOption] = useState<string>(defaultValue);
  const [dateValue, setDateValue] = useState<string>(value || "");
  const [openPicker, setOpenPicker] = useState<null | HTMLElement>(null);
  const open = Boolean(openPicker);

  const handleClickOpen = (event: React.MouseEvent<HTMLElement>) => {
    setOpenPicker(event.currentTarget);
  };
  const handleClose = () => {
    setOpenPicker(null);
  };

  const handleChangeValue = (value: string) => {
    if (value === "custom") {
      setCurrentOption(value);
      setDateValue("");
      return;
    }

    setCurrentOption(value);
    handleChangeDate("date", { value });
  };

  const handleChangeDateField = (newValue: string) => {
    setDateValue(newValue);
    handleChangeDate("date", { value: newValue });
  };

    const options: OptionType<string>[] = valueOptions.map(option => ({
        label: option.name,
        value: option.value
    }))

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box className="flex gap-2">
        <Box className="w-[180px]">
          <TextFieldInput
            variant="select"
            selectedOption={options.find(option => option.value === currentOption)}
            options={options}
            onChange={(e) => handleChangeValue(e.target.value)}
          />
        </Box>

        {currentOption === "custom" && (
          <Box className="w-[170px]">
            <TextFieldInput
              id="simple-textfield-date"
              variant="standard"
              value={dateValue}
              onClick={handleClickOpen}
              placeholder="Click to Open Picker"
            />
          </Box>
        )}
        <Menu
          id="long-menu"
          MenuListProps={{
            "aria-labelledby": "long-button",
          }}
          anchorEl={openPicker}
          open={open}
          onClose={handleClose}
        >
          <Picker value={value} handleChangeDateField={handleChangeDateField} handleClose={handleClose} />
        </Menu>
      </Box>
    </LocalizationProvider>
  );
}
